import dialogType from '../../../../display/dialogs/dialogType'

import api from '../../../../configs/api'

const transmissionMethod =
{
    title : 'Méthodes de transmission' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des méthodes de transmission dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Méthodes de transmission' ,
        uri         : api.thesaurus.medical_transmissions_methods,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default transmissionMethod ;